import decode from "jwt-decode";

var token;
export default class MaestroAppsAADService {
  setPennyToken(myToken) {
    token = myToken;
  }
  getPennyToken() {
    return token;
  }

  getPennyRoles() {
    var claims;
    if (token && null !== token) {
      claims = decode(token);
    }

    if (claims && claims.hasOwnProperty("roles")) {
      return claims.roles;
    } else {
      return null;
    }
  }

  isInRole(role) {
    if (this.getPennyRoles()) {
      for (var i = 0; i < this.getPennyRoles().length; i++) {
        if (this.getPennyRoles()[i] === role) return true;
      }
    }
    return false;
  }
}
